import { useState } from "react";

interface CollapsibleProps {
  id: string;
  title: string;
}

const CollapsibleSection: React.FC<CollapsibleProps> = ({
  id,
  title,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <h6 id={id} style={{ cursor: "pointer" }} onClick={toggleOpen}>
        {isOpen ? "🔽" : "▶️"} {title}
      </h6>
      {isOpen && <div>{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
